angular.module('iw.frontyard.signup')
    .service('BrokerSignupPage', function (SignupPage,
                                           $window,
                                           SignupLendingAPIHelper,
                                           SignupProductChoices) {

        class BrokerSignupPage extends SignupPage {
            constructor() {
                super();
                this.brokerPermission = false;
                this.selectedProduct = null;
                this.products = SignupProductChoices;
            }

            setProduct(choice) {
                if (choice.value === 'credit_line') {
                    this.setAsCreditLineProduct();
                } else {
                    this.setAsTermLoanProduct();
                    // This is currently hardcoded to 5000 as requested by the broker team
                    // FIXME: this value should at some point come from the backend API.
                    this.MIN_REQUESTED_AMOUNT = 5000;
                    this.MIN_LOAN_SIZE = 5000;
                    this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                    this.FORMATTED_MIN_REQUESTED_AMOUNT = SignupLendingAPIHelper.formatNumber(this.MIN_REQUESTED_AMOUNT);
                }
            }

            onProductChange(choice) {
                this.product = choice.value;
                this.selectedProduct = choice.name;
                this.setProduct(choice);
                this.toggleProducts();
                this.updateCreateAccountValidity();
            }

            toggleProducts() {
                this.showProducts = !this.showProducts;
            }

            isValidForApproval() {
                return this.isValidEmail()
                    && this.isEmailValidForServer !== false
                    && this.isValidRequestedAmount()
                    && this.isValidReason()
                    && this.isValidProduct()
                    && this.urgency > 1;
            }

            isValidProductAsSelectedChoice() {
                return angular.isDefined(this.selectedProduct)
                    && this.selectedProduct !== null;
            }

            isValidProduct() {
                if ($window.SITE_CODE === 'uk') {
                    return this.isValidProductAsSelectedChoice();
                }
                return true;
            }

            createAccount() {
                if (this.isValid() && this.brokerPermission) {
                    this.isInvalidOnCreateAccount = false;
                    this.hasToValidateExtraFields = false;

                    this.createAccountAndRedirect();
                } else {
                    this.isInvalidOnCreateAccount = true;
                    this.checkEmailValidity();

                    if (this.showExtraFields) {
                        this.hasToValidateExtraFields = true;
                    }
                }
            }

        }

        return BrokerSignupPage;
    });
